import React, {useMemo} from "react";
import {Button, Checkbox, Col, Dropdown, Menu, Modal, Row, Spin} from "antd";
import {ChevronRightIcon, DiamondIcon, FlameIcon, KeyIcon} from "@components/icons/Icons";
import {EllipsisOutlined, SyncOutlined, WarningOutlined} from "@ant-design/icons";
import {formatDateTiny, formatNumber, formatTitleCase} from "@lib/format";
import BookCover from "@components/book-cover";
import {FmvPrice} from "@components/fmv-price";

const MyCollectionSeriesListItemDesktop = ({
   series,
   showEditMultiple,
   isSelected,
   toggleSelected,
   navigate,
   hasIcons,
   postRefreshFmv,
   showTotalFmv,
   refreshFmvResponse,
   fmvUpdated,
   removeSeriesFromCollection,
   windowDimensions,
}) => {
    const smallButtons = useMemo(() => {
        return windowDimensions.under(1200);
    }, [windowDimensions]);

    return (
        <Row className="grid-list-item">
            {showEditMultiple && (
                <Col span={1} className="col-cbx">
                    <Checkbox
                        checked={isSelected}
                        onChange={() => toggleSelected(series.series_id)}
                    />
                </Col>
            )}
            <Col className={smallButtons ? "width-85px" : "width-135px"}>
                <div className="col-image">
                    <a href={'/series-issues?view='+series.series_id}>
                        <BookCover className="list-book-cover" issue={series} preview={false} />
                    </a>
                </div>
            </Col>

            <Col className="col-desc flex-grow-1">
                {hasIcons && (
                    <div className="valueBadges">
                        {series.overview.items_key > 0 && (<span className="pad-right-20"><div className="valueBadge keyIssue isActive"><KeyIcon /></div> ({series.overview.items_key})</span>)}
                        {series.overview.items_hot > 0 && (<span className="pad-right-20"><div className="valueBadge hotIssue isActive"><FlameIcon /></div> ({series.overview.items_hot})</span>)}
                        {series.overview.items_rare > 0 && (<span className="pad-right-20"><div className="valueBadge rareIssue isActive"><DiamondIcon /></div> ({series.overview.items_rare})</span>)}
                    </div>
                )}
                <div
                    className={'series-title ' + (hasIcons ? 'has-icons ' : '') + ' cursor-pointer titleLink'}
                    onClick={() => { navigate('series-issues?view='+series.series_id); }}
                >
                        {series.series_title}
                </div>
                <div className="ellipsis">
                    {series.publisher} | {series.year_began}
                </div>
            </Col>
            <Col span={3} className="flex-col">
                <div className="col-center">
                    {formatNumber(series.overview.items)}
                </div>
            </Col>
            <Col
                span={4}
                className={"flex-col " + (series.fmv_can_update ? 'cursor-pointer' : '')}
                onClick={(showTotalFmv && series.fmv_can_update) ? async () => {
                    await postRefreshFmv({series_id: series.series_id})
                } : undefined}
            >
                <div className="col-center">
                    {showTotalFmv ? (
                        <Spin spinning={refreshFmvResponse.isLoading}>
                            <Row className="flex-align-center">
                                <FmvPrice
                                    value={series.fmv}
                                    stale={series.fmv_is_stale}
                                    staleInfo="FMV data is stale, please update."
                                />
                                {series.fmv_can_update && (<SyncOutlined className={'fmv-update can-update'} />)}
                            </Row>
                            {(series.fmv_can_update && fmvUpdated) && (
                                <Row className="flex-align-center">
                                    <span className='font-10 text-grey'>Updated: {formatDateTiny(fmvUpdated)}</span>
                                </Row>
                            )}
                        </Spin>
                    ) : (
                        <a className="upgrade-link" href="/plans/unlimited/">Upgrade</a>
                    )}
                </div>
            </Col>
            <Col span={3} className="flex-col">
                <div className="col-center">
                    {formatTitleCase(series.format)}
                </div>
            </Col>
            <Col span={3} className="flex-col">
                <div className="flex-align-center flex-vertical-center height-100">
                    <Dropdown className="greyButton selectButton" trigger={["click"]} overlay={(
                        <Menu >
                            {/*<Menu.Item key={1} disabled >Mark All As Sold</Menu.Item>*/}
                            <Menu.Item key={2}
                               onClick={() => Modal.confirm({
                                   autoFocusButton: null,
                                   icon: <WarningOutlined />,
                                   content: (<div>
                                       <div><b>Delete Series</b></div>
                                       <div className="pad-top-10">
                                           Are you sure?<br/>
                                           Selecting this option will delete these series permanently. This action cannot be undone.
                                       </div>
                                   </div>),
                                   onOk() {
                                       removeSeriesFromCollection({series_ids: [series.series_id]});
                                   },
                               })}
                            >Delete Series</Menu.Item>
                            <Menu.Item key={3}><a href={series.series_permalink}>Go To Full Series</a></Menu.Item>
                            {/*<Menu.Item key={3} disabled>Mark all listed for sale</Menu.Item>*/}
                            {/*<Menu.Item key={4} disabled>add to pull list</Menu.Item>*/}
                        </Menu>
                    )}>
                        <Button size="large" className="greyButton mar-left-5">
                            <EllipsisOutlined className="font-12" />
                        </Button>
                    </Dropdown>

                    <Button
                        type="text"
                        size="large"
                        className="pad-0-10"
                        href={'/series-issues?view='+series.series_id}
                    >
                        <ChevronRightIcon className="icon30 iconGrey"/>
                    </Button>
                </div>
            </Col>
        </Row>
    );
};

export default MyCollectionSeriesListItemDesktop;